import RouteName from '@/models/enums/RouteName'

export const mainLinksGroups = [
  {
    title: 'Выручка',
    links: [
      {
        icon: 'chart-line',
        title: 'Динамика выручки',
        routeName: RouteName.RevenueDynamicsStat,
        cols: 12,
        soon: false,
      },
      {
        icon: 'chart-pie',
        title: 'Распределение выручки',
        routeName: RouteName.CashSourcesStat,
        cols: 6,
        soon: false,
      },
      {
        icon: 'map-pin',
        title: 'Зоны',
        cols: 6,
        soon: true,
      },
    ],
  },
  {
    title: 'Сотрудники',
    links: [
      {
        icon: 'calendar-alt',
        title: 'График смен',
        routeName: RouteName.WorkSchedulesStat,
        cols: 12,
        soon: false,
      },
      {
        icon: 'exclamation-triangle',
        title: 'Опоздания и рекламации',
        cols: 12,
        soon: true,
      },
    ],
  },
  {
    title: 'Блюда',
    links: [
      {
        icon: 'money-bill-wave',
        title: 'FOOD COST',
        cols: 12,
        soon: true,
      },
      {
        icon: 'chart-bar',
        title: 'ABC анализ',
        routeName: RouteName.MenuAbcStat,
        cols: 12,
      },
    ],
  },
  {
    title: 'Агрегаторы',
    links: [
      {
        icon: 'chart-bar',
        title: 'ABC анализ',
        routeName: RouteName.AggregatorsAbcStat,
        cols: 12,
      },
      {
        icon: 'coins',
        title: 'Выручка и заказы',
        routeName: RouteName.AggregatorsRevenueDynamicsStat,
        cols: 12,
      },
    ],
  },
  {
    title: 'Внешние коннекторы',
    links: [
      {
        icon: 'chart-bar',
        title: 'ABC анализ',
        routeName: RouteName.ConnectorsAbcStat,
        cols: 12,
      },
      {
        icon: 'coins',
        title: 'Выручка и заказы',
        routeName: RouteName.ConnectorsRevenueDynamicsStat,
        cols: 12,
      },
    ],
  },
  {
    title: 'Клиенты',
    links: [
      {
        icon: 'address-book',
        title: 'Клиентская база',
        routeName: RouteName.ClientsStat,
        cols: 12,
        soon: false,
      },
      {
        icon: 'people-arrows',
        title: 'RFM / LTV',
        cols: 12,
        soon: true,
      },
    ],
  },
  {
    title: 'Заказы',
    links: [
      {
        icon: 'shopping-basket',
        title: 'Заказы',
        cols: 12,
        soon: true,
      },
      {
        icon: 'ban',
        title: 'Отмены',
        cols: 6,
        soon: true,
      },
      {
        icon: 'headset',
        title: 'Колл-центр',
        cols: 6,
        soon: true,
      },
    ],
  },
  {
    title: 'Маркетинг',
    links: [
      {
        icon: 'ticket-alt',
        title: 'Промокоды',
        cols: 12,
        soon: true,
      },
      {
        icon: 'link',
        title: 'Источники',
        cols: 6,
        soon: true,
      },
      {
        icon: 'coins',
        title: 'COIN (бонусы)',
        cols: 6,
        soon: true,
      },
    ],
  },
  {
    title: 'Сервис',
    links: [
      {
        icon: 'star',
        title: 'Рейтинг',
        routeName: RouteName.RatingStat,
        cols: 12,
        soon: false,
      },
      {
        icon: 'stopwatch',
        title: 'СВО',
        cols: 6,
        soon: true,
      },
      {
        icon: 'stopwatch-20',
        title: 'СВП',
        cols: 6,
        soon: true,
      },
    ],
  },
  {
    title: 'Доставка',
    links: [
      {
        icon: 'running',
        title: 'Анализ курьеров',
        routeName: RouteName.CourierStat,
        cols: 6,
        soon: false,
      },
      {
        icon: 'stopwatch',
        title: 'СВД',
        cols: 6,
        soon: true,
      },
      {
        icon: 'map',
        title: 'Зоны доставки',
        cols: 6,
        soon: true,
      },
      {
        icon: 'hand-pointer',
        title: 'Click to eat',
        cols: 6,
        soon: true,
      },
    ],
  },
  {
    title: 'Безопасность',
    links: [
      {
        icon: 'shield-alt',
        title: 'Логины и анти-фрод',
        routeName: RouteName.LoginStat,
        cols: 12,
        soon: false,
      },
    ],
  },
]

export const callCenterLinksGroups = [
  {
    title: 'ЗАКАЗЫ',
    links: [
      {
        icon: 'shopping-basket',
        title: 'Заказы',
        routeName: RouteName.CallCenterOrdersStat,
        cols: 12,
        soon: false,
      },
      {
        icon: 'stopwatch',
        title: 'СВП',
        cols: 6,
        soon: true,
      },
      {
        icon: 'ban',
        title: 'Отмены',
        cols: 6,
        soon: true,
      },
    ],
  },
  {
    title: 'ФИЛИАЛЫ',
    links: [
      {
        icon: 'clipboard-list',
        title: 'Отчетность по филиалам',
        routeName: RouteName.CallCenterFilialsStat,
        cols: 12,
        soon: false,
      },
      {
        icon: 'thumbs-down',
        title: 'Бонусы за негатив',
        cols: 12,
        soon: true,
      },
    ],
  },
  {
    title: 'СОТРУДНИКИ',
    links: [
      {
        icon: 'user',
        title: 'Отчет по сотрудникам КЦ',
        routeName: RouteName.CallCenterEmployeesStat,
        cols: 12,
        soon: false,
      },
      {
        icon: 'calendar-alt',
        title: 'График смен',
        routeName: RouteName.CallCenterEmployeesWorkScheduleStat,
        cols: 12,
        soon: false,
      },
    ],
  },
]
